import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, DemoBadge, LiveBadge } from "../components/common/PageParts";
import { Brain, Newspaper, Landmark, Globe, Link2, ArrowRight } from "lucide-react";

const ICONS = { news: Newspaper, macro: Landmark, geopolitical: Globe, onchain: Link2 };

export default function MarketIntelligence() {
  const [data, setData] = useState(null);
  useEffect(() => { api.getIntelligence().then(setData).catch(() => {}); }, []);

  return (
    <div className="ym-fade">
      <PageHeader title="Market Intelligence" subtitle="News, Macro / Fed, Geopolitical & On-chain / ETF flow"
        right={<span className="pill" style={{ color: "var(--accent-soft)", background: "rgba(139,92,246,.12)", borderColor: "transparent" }}><Brain size={13} /> Multi-source</span>} />

      <div className="ym-card p-3 mb-4 flex items-start gap-3" style={{ borderColor: "rgba(245,158,11,.3)", background: "rgba(245,158,11,.05)" }}>
        <DemoBadge />
        <p className="text-[12px]" style={{ color: "var(--text-muted)" }}>
          These feeds require paid provider API keys you haven't supplied yet. Connectors and Test Connection are built in <b style={{ color: "var(--text)" }}>Settings</b>.
          Content below is clearly labelled DEMO and is never presented as live. Add a key to switch a section to LIVE.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {(data?.sections || []).map((s) => {
          const Icon = ICONS[s.key] || Newspaper;
          return (
            <div key={s.key} className="ym-panel p-4">
              <div className="flex items-center gap-2.5 mb-3">
                <div className="grid place-items-center rounded-lg" style={{ width: 32, height: 32, background: "var(--panel-2)", border: "1px solid var(--border)" }}>
                  <Icon size={16} style={{ color: "var(--accent-soft)" }} />
                </div>
                <h3 className="text-[13px] font-bold">{s.label}</h3>
                <span className="ml-auto">{s.status === "live" ? <LiveBadge /> : <DemoBadge />}</span>
              </div>
              <div className="space-y-2">
                {s.items.map((it, i) => (
                  <div key={i} className="rounded-lg p-2.5" style={{ background: "var(--panel-2)", border: "1px solid var(--border)" }}>
                    <div className="text-[12px] leading-snug">{it.title}</div>
                    <div className="flex items-center gap-2 mt-1 text-[10px]" style={{ color: "var(--text-dim)" }}>
                      <span>{it.source}</span><span>·</span><span>{it.time}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-3 flex items-center gap-1.5 text-[11px]" style={{ color: "var(--text-dim)" }}>
                <ArrowRight size={12} /> Requires: <span className="tabnum" style={{ color: "var(--accent-soft)" }}>{s.requiresKey}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
